import { withBasePath } from '@/utils/basePath';

export const TESTIMONIALS = [
  {
    cabinet: 'Librato Avocats',
    client: 'Mme Christophe Thevenet, Avocat.',
    description:
      'Un logiciel de gestion est indispensable à tout avocat, autant choisir le meilleur !',
    logo: withBasePath('/images/testimonials/librato.webp'),
  },
  {
    cabinet: 'Kiejman & Marembert Avocats',
    client: 'Me Thierry Marembert, Avocat.',
    description:
      'Après avoir fait une analyse des logiciels disponibles pour les cabinets d’avocats, nous avons choisi zLawyer car c’est celui qui nous a paru le plus complet et le plus intuitif d’utilisation. Après quelques mois d’utilisation, on peut dire que zLawyer à l’épreuve du terrain répond complètement à notre attente.',
    logo: withBasePath('/images/testimonials/kiejman.webp'),
  },
  {
    cabinet: 'Richelieu Avocats',
    client: 'Me Benoît Gruau, Avocat.',
    description:
      "Le logiciel zLawyer ? en un mot ? ...la FACILITE ! C'est une solution très agréable et très simple. Il nous est devenu indispensable et il ne tombe jamais en panne.",
    logo: withBasePath('/images/testimonials/richelieu.webp'),
  },
  {
    cabinet: 'Sekri Valentin Zerouk Avocats',
    client: 'Me Valérie Goffinon, Secrétaire Général.',
    description:
      'C’est sans conteste le meilleur logiciel de facturation et de gestion et le plus easy-using avec une équipe hyper professionnelle et hyper réactive. Nous utilisons ZL depuis 7 ans et nous n’avons jamais rencontré aucun problème.',
    logo: withBasePath('/images/testimonials/sekriValentinZerrouk.webp'),
  },
  {
    cabinet: 'Voltaire Avocats',
    client: 'Me David Guillouet, Avocat.',
    description:
      'Cela va bientôt faire 10 ans que nous utilisons Z. Un logiciel ergonomique, convivial et d’une simplicité de déploiement et d’utilisation appréciée par l’ensemble de notre équipe. A recommander les yeux fermés.',
    logo: withBasePath('/images/testimonials/mggVoltaire.webp'),
  },
  {
    cabinet: 'Ad Hoc Avocats',
    client: 'Me Thomas Cuq, Avocat.',
    description:
      'J’utilise zLawyer depuis des années. Cet outil me permet de facturer en deux clics et d’obtenir une analyse détaillée de la rentabilité de mes dossiers. En plus de cela, l’équipe dédiée au support est vraiment très réactive. Je recommande à 200% !',
    logo: withBasePath('/images/testimonials/adHoc.webp'),
  },
  {
    cabinet: 'Advance Avocats',
    client: 'Me Nacime Tobni, Avocat.',
    description:
      'J’utilise zLawyer depuis plusieurs années. Il est devenu un outil de facturation incontournable au sein du cabinet. Le vrai plus, une équipe à l’écoute de ses clients et très réactive.',
    logo: withBasePath('/images/testimonials/advanceAvocats.webp'),
  },
] as const;
